import config from '../config/env';

export function normalizeUrl(url) {
  if (!url) return '';
  return url.replace(/\/+$/, '');
}

export function buildUrl(base, path) {
  const cleanBase = normalizeUrl(base);
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
}

export function generateState() {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function saveAuthState(state) {
  sessionStorage.setItem('auth_state', state);
}

export function validateAuthState(returnedState) {
  const stored = sessionStorage.getItem('auth_state');
  return stored && stored === returnedState;
}

export function clearAuthState() {
  sessionStorage.removeItem('auth_state');
  sessionStorage.removeItem('postLoginRedirect');
}

export function savePostLoginRedirect(path) {
  sessionStorage.setItem('postLoginRedirect', path || '/');
}

export function getPostLoginRedirect() {
  const path = sessionStorage.getItem('postLoginRedirect') || '/';
  sessionStorage.removeItem('postLoginRedirect');
  return path;
}

export function buildLoginRedirectUrl(currentPath) {
  const state = generateState();
  saveAuthState(state);
  savePostLoginRedirect(currentPath);

  const returnUrl = `${config.DOMAIN}${config.AUTH_CALLBACK_PATH}`;

  const url = new URL(config.LOGIN_REDIRECT_URL);
  url.searchParams.set('returnUrl', returnUrl);
  url.searchParams.set('state', state);
  url.searchParams.set('source', 'learnovative');

  return url.toString();
}
